module.exports = __webpack_public_path__ + "static/media/re.ed3d424e.mp3";